
// Import dinâmico para que o Module Federation negocie
// dependências compartilhadas antes do bootstrap.
import('./bootstrap').catch(err => console.error(err));
